import { defineMessages } from 'react-intl';

export const emojiPickerFavoriteMessages = defineMessages({
  favorites: { id: 'emoji_button.favorites', defaultMessage: 'Favorites' },
  add_to_favorites: {
    id: 'emoji_button.add_to_favorites',
    defaultMessage: 'Add to Favorites',
  },
  already_in_favorites: {
    id: 'emoji_button.already_in_favorites',
    defaultMessage: 'Already in Favorites',
  },
  remove_from_favorites: {
    id: 'emoji_button.remove_from_favorites',
    defaultMessage: 'Remove from Favorites',
  },
});
